var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "container" }, [
      _vm.isInitial || _vm.isSaving
        ? _c(
            "form",
            { attrs: { enctype: "multipart/form-data", novalidate: "" } },
            [
              _c("div", { staticClass: "dropbox" }, [
                _vm.isInitial
                  ? _c("p", [
                      _vm._v(
                        "\n\t\t\t\t\tSläpa dina filer hit för att påbörja uppladdning"
                      ),
                      _c("br"),
                      _vm._v(" eller klicka här för att välja fil.\n\t\t\t\t")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSaving
                  ? _c("p", [
                      _vm._v(
                        "\n\t\t\t\t\tLaddar upp " +
                          _vm._s(_vm.fileCount) +
                          " fil...\n\t\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  staticClass: "input-file",
                  attrs: {
                    type: "file",
                    multiple: "",
                    name: _vm.uploadFieldName,
                    disabled: _vm.isSaving,
                    accept: ".csv"
                  },
                  on: {
                    change: function($event) {
                      _vm.filesChange($event.target.name, $event.target.files)
                      _vm.fileCount = $event.target.files.length
                    }
                  }
                })
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }